import { AutocompletionRequest } from "react-google-places-autocomplete/build/types";
import { StylesConfig } from "react-select";
import { ThemeConfig } from "react-select";

// Default autocomplete options
export const autocompleteOptions: AutocompletionRequest = {
    componentRestrictions: { country: "nz" },
    types: ["(regions)"],
};

export const autocompleteStyles: StylesConfig = {
    control: (base, { isFocused }) => ({
        ...base,
        fontSize: "16px",
        lineHeight: "24px",
        fontFamily: "var(--font-body)",
        background: "#fff",
        color: "var(--color-grey-400)",
        ":hover": {
            borderColor: isFocused
                ? "var(--color-focus)"
                : "var(--color-grey-200)",
        },
    }),
    noOptionsMessage: (base) => ({
        ...base,
        fontSize: "16px",
        lineHeight: "24px",
        fontFamily: "var(--font-body)",
        color: "var(--color-grey-400)",
    }),
    loadingMessage(base) {
        return {
            ...base,
            fontSize: "16px",
            lineHeight: "24px",
            fontFamily: "var(--font-body)",
            color: "var(--color-grey-400)",
        };
    },
    menu: (base) => ({
        ...base,
        background: "var(--color-white)",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
};

export const autocompleteTheme: ThemeConfig = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary: "var(--color-focus)",
        primary25: "var(--color-ministry-blue-100)",
        neutral0: "var(--color-grey-50)",
        neutral10: "var(--color-grey-100)",
        neutral20: "var(--color-grey-200)",
        neutral30: "var(--color-grey-400)",
        neutral40: "var(--color-grey-400)",
        neutral50: "var(--color-grey-400)",
    },
});
